export default {
  translation: {
    common: {
      emailOrUsername: 'E-mail sau nume de utilizator',
      invalidEmailOrUsername: 'E-mail sau nume de utilizator introduse greșit',
      invalidPassword: 'Parola greșita',
      noInternetConnection: 'Lipsește conexiunea cu internet',
      pageNotFound_title: 'Pagina n-a fost găsită',
      password: 'Parola',
      projectManagement: 'Gestionarea proiectului',
      serverConnectionFailed: 'Conexiunea cu Server a eșuat',
      unknownError: 'Eroarea necunoscuta, mai incercați',
      useSingleSignOn: 'Folosiți autentificarea unica',
    },

    action: {
      logIn: 'Autentificarea',
      logInWithSSO: 'Autentificarea cu SSO',
    },
  },
};
